import React, { useEffect, useRef } from 'react'; // Import useRef and useEffect
import { Box, Typography, TextField, Button } from '@mui/material';
import { useCardContext } from 'contexts/CardContext'; // Import the CardContext

export default function CompanyInfo({ onContinue }) {
  // Access state and setter functions from CardContext
  const { cardId, cardState, setCardJobTitle, setCardCompany } = useCardContext();

  // Fetch specific card data using optional chaining
  const cardJobTitle = cardState[cardId]?.cardJobTitle || '';
  const cardCompany = cardState[cardId]?.cardCompany || '';
  const cardFullName = cardState[cardId]?.cardFullName || '';

  const jobTitleRef = useRef(null); // Create a ref for the job title input

  // Focus the job title input when the component mounts
  useEffect(() => {
    if (jobTitleRef.current) {
      jobTitleRef.current.focus();
    }
  }, []);

  useEffect(() => {
    console.log('Card full name from the companyinfo page:', cardFullName);
  }, [cardFullName]);

  // Handler for job title change
  const handleCardJobTitleChange = (event) => {
    const newCardJobTitle = event.target.value;
    setCardJobTitle(cardId, newCardJobTitle); // Update the job title in the context state
  };

  // Handler for company change
  const handleCardCompanyChange = (event) => {
    const newCardCompany = event.target.value;
    setCardCompany(cardId, newCardCompany); // Update the company name in the context state
  };

  // Handle key down event
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default form submission
      onContinue(); // Call the onContinue function
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: 3,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Where do you work?
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: 2 }}>
        Add your job title and company to your digital business card.
      </Typography>

      <TextField
        label="Job Title"
        inputRef={jobTitleRef} // Set the ref here
        value={cardJobTitle} // Bind the input value to cardJobTitle from context
        onChange={handleCardJobTitleChange} // Handle the change to update cardJobTitle in context
        onKeyDown={handleKeyDown} // Handle key down event
        variant="outlined"
        fullWidth
        sx={{ marginBottom: 2 }}
        placeholder="e.g. Software Engineer"
      />

      <TextField
        label="Company"
        value={cardCompany} // Bind the input value to cardCompany from context
        onChange={handleCardCompanyChange} // Handle the change to update cardCompany in context
        onKeyDown={handleKeyDown} // Handle key down event
        variant="outlined"
        fullWidth
        sx={{ marginBottom: 3 }}
        placeholder="e.g. Google"
      />

      <Button
        variant="contained"
        color="primary"
        sx={{ backgroundColor: 'blue', borderRadius: '4px', textTransform: 'none' }}
        onClick={onContinue}
      >
        Continue
      </Button>
    </Box>
  );
}